import $ from "jquery";

// TODO: Update dumbcrossfade
require("../vendor/jquery.dumbcrossfade");
export class ModFwSlideShow {
  constructor() {
    var $window = $(window),
      $moduleContainer,
      $slideshow,
	    $moduleContainer = $(".slide_l_image_only_module"),
	    $slideshow = $moduleContainer.find(".slide"),
	    $slideshowOptions = $moduleContainer.find(".slide_text_options");

    // $slideshow.css("display", "none");
    // $(".s_a_text_options a:first").addClass("optionSelected");

    var options = {
      slideChange: function(currentSlideIndex) {
        $(".slide_text_options a").removeClass("optionSelected");
        $(".slide_text_options a:eq(" + currentSlideIndex + ")").addClass(
          "optionSelected"
        );
      },
      slideType: "fade",

      showTime: 8000
    };
    var slides_a_standardshow = $slideshow.dumbCrossFade(options);
    var i = 0;
    var j = 1;

    $("#previousslide_l_image_onlybutton").click(function() {
      $slideshow.dumbCrossFade("previous");
      return false;
    });
    $("#nextslide_l_image_onlybutton").click(function() {
      $slideshow.dumbCrossFade("next");
      return false;
    });
    $slideshow.first().addClass("activeS");
    /*$slideshow.each(function() {
      $(".slide_text_options").append(
        '<li class=" test slide_text_option"><a href=""  id="btn' +
          j +
          '" class="button">' +
          j +
          "</a></li>"
      );

      j++;
    });*/

    $(".slide_text_options a").each(function() {
      $(this).attr("href", i + "");
      i++;
    });
    $(".slide_text_options a").click(function() {
      event.preventDefault();
      $slideshow.dumbCrossFade("jump", parseInt($(this).attr("href")));
      return false;
    });

    $slideshowOptions
      .first(".slide_text_option")
      .find("a")
      .addClass("optionSelected");

    $moduleContainer.removeClass("invisible");
  }
}
